// @flow
import AppVersion from 'app/common/lib/AppVersion';
import Csrf from 'app/common/lib/Csrf';
import urlUtil from 'app/common/lib/urlUtil';
import ajax, { type Options } from 'app/packages/api/ajax';

export const ajaxWithAbort = (options: Options) =>
  ajax(options, {
    csrf: {
      isRequired: Csrf._needsCsrfToken,
      errorIfMissing: false,
      getToken: Csrf.getCSRFToken,
    },
    getAppVersion: () => AppVersion.currentVersion,
    appendQuery: urlUtil.appendQueryString,
    buildQuery: urlUtil.getQueryStringFromObject,
  });

const desktopAjax = (options: Options) => ajaxWithAbort(options).promise;

export default desktopAjax;
